import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import { getAssetURL } from "../../utils";
import content from "../../includes/content";
import {
  FacebookCard,
  InstagramCard,
  LinkedInCard,
  XCard,
} from "../SocialCards";

const ShareBox = ({
  makeDefaultPrivate,
  setCustomURL,
  setSaveCustom,
  setTempURL,
  tempURL,
  loan,
  urlTernary,
}) => {
  const [edit, setEdit] = useState(false);
  const urlPrefix = process.env.REACT_APP_CERT_URL;

  const handleAni = (ele, ani) => {
    const aniEle = document.getElementsByClassName(ele)[0];

    aniEle.classList.add(ani);
    setTimeout(() => {
      aniEle.classList.remove(ani);
    }, 1000);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "I Am Tru Approved!",
          text: "Secure your future with Tru Approval by Sun West Mortgage Company, LLC",
          url: `${urlPrefix}${urlTernary}`,
        });
        console.log("Shared successfully");
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      console.log("Web Share API not supported");
    }
  };
  return (
    <div className="d-flex flex-column justify-content-center align-items-center mb-3">
      <div className="share-box">
        <p className="share-title">Customize your URL for the Certificate</p>
        <div className="custom-url-box d-flex justify-content-center align-items-center">
          {edit ? (
            <input
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus
              className="custom-url-text edit"
              onChange={(e) => {
                setTempURL(e.target.value);
              }}
              type="text"
              value={tempURL}
            />
          ) : (
            <div className="custom-url-text">{`${urlPrefix}${urlTernary}`}</div>
          )}
          {!edit && (
            <Image
              onClick={() => {
                setEdit((prev) => !prev);
              }}
              style={{ marginLeft: "0.5rem", cursor: "pointer" }}
              className="ml-5"
              src={getAssetURL("pencil-icon.svg")}
            />
          )}
        </div>
        {edit ? (
          <div
            style={{
              borderBottom: "1px solid rgb(88,88,88,0.5)",
            }}
            className="d-flex w-100 justify-content-center align-items-center"
          >
            <div
              onClick={() => {
                setEdit(false);
                makeDefaultPrivate();
                setCustomURL(tempURL);
                setSaveCustom(true);
              }}
              role="button"
              tabIndex="0"
              className="share-save"
              onKeyDown={(e) => {
                const log = e.key.toLowerCase();
                if (log === "enter") {
                  setEdit(false);
                  makeDefaultPrivate();
                  setCustomURL(tempURL);
                  setSaveCustom(true);
                }
              }}
            >
              Save
            </div>{" "}
            <div
              role="button"
              tabIndex="-1"
              onClick={() => {
                setEdit(false);

                setTempURL(urlTernary);
              }}
              className="share-save"
              onKeyDown={(e) => {
                const log = e.key.toLowerCase();
                if (
                  log === "escape" ||
                  log === "backspace" ||
                  log === "delete"
                ) {
                  setEdit(false);
                  makeDefaultPrivate();
                  setCustomURL(tempURL);
                  setSaveCustom(true);
                }
              }}
            >
              Cancel
            </div>
          </div>
        ) : (
          <React.Fragment />
        )}
        <div className="d-flex justify-content-center align-items-center my-2">
          <div
            tabIndex="-2"
            role="button"
            onKeyDown={() => {
              navigator.clipboard.writeText(`${urlPrefix}${urlTernary}`);
            }}
            className="share-text d-flex align-items-center justify-content-center text-center"
            onClick={() => {
              navigator.clipboard.writeText(`${urlPrefix}${urlTernary}`);
              handleAni("chain", "spin");
            }}
          >
            <Image className="chain" src={getAssetURL("chain-icon.svg")} />
            Copy Link
            <div className="copy-msg">Link Copied!</div>
          </div>{" "}
          <div
            onClick={() => handleAni("mail", "fullsend")}
            className="share-text d-flex align-items-center justify-content-center"
          >
            <a
              target="_blank"
              rel="noreferrer"
              href={`mailto:?subject=${content.productName}&body=Look at this, I'm approved! ${urlPrefix}${urlTernary}`}
              onClick={handleShare}
            >
              <Image className="mail" src={getAssetURL("envelope-icon.svg")} />
              Share
            </a>
          </div>
        </div>
        <div className="share-social w-100 mt-3 d-flex justify-content-around align-items-center">
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://www.facebook.com/sharer/sharer.php?u=${urlPrefix}${urlTernary}`}
            className="fb-xfbml-parse-ignore share-link
            "
          >
            <Image className="social-icon" src={getAssetURL("fb-icon.svg")} />
            <div className="fb share-post-box fadeInFast">
              <div className="tap-to-post">Tap here to Post to Facebook.</div>
              <FacebookCard loan={loan} />
            </div>
          </a>
          <a
            href="https://www.instagram.com/sunwestmortgage.inc/"
            target="_blank"
            rel="noreferrer"
            className="share-link"
          >
            <Image className="social-icon" src={getAssetURL("insta.svg")} />
            <div className="insta share-post-box fadeInFast">
              <div className="tap-to-post">Tap here to Post to Instagram.</div>
              <InstagramCard loan={loan} />
            </div>
          </a>
          <a
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${urlPrefix}${urlTernary}&text=${content.postTagline(loan)}`}
            target="_blank"
            rel="noreferrer"
            className="share-link"
          >
            <Image className="social-icon" src={getAssetURL("li-icon.svg")} />
            <div className="lnk share-post-box fadeInFast">
              <div className="tap-to-post">Tap here to Post to LinkedIn.</div>
              <LinkedInCard loan={loan} />
            </div>
          </a>
          <a
            className="twt_box share-link"
            href={`https://x.com/intent/tweet?url=${urlPrefix}${urlTernary}&text=${content.postTagline(
              loan
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image className="social-icon" src={getAssetURL("X.png")} />
            <div className="X share-post-box fadeInFast">
              <div className="tap-to-post">Tap here to Post to X.</div>
              <XCard loan={loan} />
            </div>
          </a>
        </div>
      </div>

      {/* <button className="light-button bottom-margin" type="button">
        Click Here to Make it Private
        <input
          type="checkbox"
          checked={publicToggle}
          className="toggle-public"
          name="checkPublic"
          onChange={(e) => {
            const check = e.target.checked;
            setPublicToggle(check);
            setTempURL(initialURL);
            makePrivate();
            setCustomURL(initialURL);
          }}
        />
      
      </button> */}
    </div>
  );
};
export default ShareBox;
